import React from 'react'

import { SETTINGS } from '../_services/services'
import { getSubdomain } from '../../../packages/kiti/utils/helpers/url'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useOpenEditIntegrationTokenModal } from '../../../utils/routes/modals/modalsActions'
import IconButton from '../../../packages/kiti/components/actions/IconButton'

const CreateNewIntegrationButton = () => {
  const workspace = getSubdomain()
  const { service } = useModalData()
  const serviceData = SETTINGS[service]
  const openTokenModal = useOpenEditIntegrationTokenModal()

  const handleClick = () => {
    if (serviceData.Form) {
      openTokenModal({ service: serviceData.key, moveBackOnSuccess: true })
    } else {
      serviceData.onInstall(serviceData, true)
    }
  }

  return <IconButton icon="RiAddCircleLine" label="Nova conta" color="dark3" onClick={handleClick} />
}

export default CreateNewIntegrationButton
